import React from 'react';
import { Tooltip } from 'reactstrap';

const emailPattern = /^[^\s@]+@[^\s@]+\.[A-Za-z0-9]+[A-Za-z0-9-/.]*[A-Za-z0-9]+$/;    //basic email regex // requires TLD of length 2, beginning and end chars must be alphanumeric, - and . are allowed

class Email extends React.Component {
    constructor(props) {
        super(props)
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.clearInput = this.clearInput.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onChange = this.onChange.bind(this);
        const { value } = this.props;
        this.state = {
            tooltipOpen: false,
            invalidInput: false,
            isEmailEmpty: value ? false : true
        };
    }

    toggleTooltip() {
        this.setState(prevState => ({
            tooltipOpen: !prevState.tooltipOpen
        }));
    }

    onKeyUp(event) {
        if (event.target.value) {
            if (this.state.isEmailEmpty) {
                this.setState({ invalidInput: false })
            }
            let isValid = this.isValid(event.target.value);
            if (!this.state.isEmailEmpty) {
                this.setState({ invalidInput: !isValid })
            }
        }
    }

    onChange(event) {
        const { value } = event.target;
        this.props.onChange(event, this.isValid(value));
    }

    childValidationMethod() {
        const { childValidationMethod, value } = this.props;
        if (childValidationMethod) {
            let isValid = this.isValid(value);
            childValidationMethod(isValid)
            if (!isValid) {
                this.setState({ invalidInput: true })
            }
        }
    }

    isValid(value) {
        return !this.props.inValidMsg && value && value.trim() && emailPattern.test(value);
    }

    clearInput(event) {
        const e = { event, target: { value: "", name: this.props.name ? this.props.name : "" } };
        this.onChange(e);
    }

    validateOnBlur(event) {
        const { value } = event.target;
        this.props.onChange(event, this.isValid(value));
        if (this.props.required) {
            event.persist()
            this.setState({
                isEmailEmpty: !value.trim()
            });
            if (value && !this.props.inValidMsg) {
                var validPattern = emailPattern.test(value);
                if (validPattern) {
                    this.setState({ invalidInput: false });
                } else {
                    this.setState({ invalidInput: true });
                }
            } else {
                this.setState({ invalidInput: true });
            }

        }
    }

    render() {
        const {
            placeholder,
            value,
            required,
            name,
            id,
            autoFocus,
            disabled,
            inputErrorMsg,
            tooltipID,
            tooltipMsg,
            inValidMsg,
            showAsInvalid,
            showClearBtn
        } = this.props;
        const { isEmailEmpty } = this.state;
        const isValid = (!required && isEmailEmpty) || this.isValid(value);
        const containerClassName = (!isEmailEmpty ? ' input-not-empty' : '') + (this.state.invalidInput || showAsInvalid ? ' input-invalid' : '') + ((tooltipID && tooltipMsg) ? ' input-append' : '');

        return (
            <div className={'il-group' + containerClassName}>
                <input
                    type="email"
                    className="form-control"
                    value={value}
                    required={required}
                    name={name}
                    id={id}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    placeholder={placeholder ? placeholder : 'Email'}
                    onChange={e => this.onChange(e)}
                    onKeyUp={e => this.onKeyUp(e)}
                    onKeyDown={e => this.onKeyUp(e)}
                    onBlur={this.validateOnBlur}
                    title={placeholder ? "Please fill out the " + placeholder : "Please fill out the Email."}
                    aria-label={placeholder ? placeholder : 'Email'}
                />
                {tooltipID && tooltipMsg && (
                    <div className="input-icon-append ">
                        <span className="icon-info" id={tooltipID} />
                        <Tooltip
                            placement="top"
                            isOpen={this.state.tooltipOpen}
                            autohide={false}
                            target={tooltipID}
                            toggle={this.toggleTooltip}
                        >
                            {tooltipMsg}
                        </Tooltip>
                    </div>
                )}
                {showClearBtn && value && <span className="clear-btn" aria-label="clear button" onClick={this.clearInput}><span className="icon-input-clear" /></span>}
                <div className="il-label" aria-hidden="true">{placeholder}</div>
                <div className="input-icon-append"><span className="icon-envelop" /></div>

                {inValidMsg ?
                    <div className="input-error-msg">{inValidMsg}</div>
                    :
                    !isValid && <div className="input-error-msg">
                        {
                            inputErrorMsg ? inputErrorMsg : (typeof value !== "undefined" && value) ? "Please enter a valid email." : ""
                        }
                    </div>
                }
            </div>
        )
    }
}
export default Email;
